var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('templateHeader'),_c('div',[_c('router-view',{key:_vm.$route.fullPath})],1),_c('templateFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }